import {TreeNode} from "primeng/api";
import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Classifications} from './classifications';

@Injectable()
export class ClassificationsService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('classifications?' + params.toString()).map((response: Response) => response.json());
    }
    getAllClassifications() {
        return this.http.get('taskcategories/all').map((response: Response) => response.json());
    }

    getall() {
        return this.http.get('classifications/all').map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get('classifications/' + _id).map((response: Response) => response.json());
    }

    getTree(_id:string) {
        return this.http.get('classifications/tree/' + _id).toPromise().then(res => <TreeNode[]> res.json());
    }

    checklast(_id: string) {
        return this.http.get('classifications/checklast/' + _id).map((response: Response) => response.json());
    }

    getParents(_id: string) {
        return this.http.get('classifications/parents/' + _id).map((response: Response) => response.json());
    }

    getTrashedById(_id: string) {
        return this.http.get('classifications/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('classifications/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(Classifications: Classifications) {
        return this.http.post('classifications', Classifications).map((response: Response) => response.json());
    }

    update(Classifications: Classifications) {
        return this.http.put('classifications/' + Classifications.id, Classifications).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('classifications/' + _id).map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/classifications/classifications.service.ts